/// <amd-module name="Build/Admin/Agent/Components/AddUserCapabilityPanel" />
import * as React from "react";

import { FormItem } from "VSSUI/FormItem";
import { Panel } from "VSSUI/Panel";
import { TextField } from "VSSUI/TextField";

import * as Resources from "Build/Admin/Agent/Resources";

export interface IAddUserCapabilityPanelProps {
    isOpen: boolean;
    onUserCapabilityAdded(name: string, value: string): void;
    onDismiss(): void;
}

interface IAddUserCapabilityPanelState {
    name: string;
    value: string;
}

export class AddUserCapabilityPanel extends React.Component<IAddUserCapabilityPanelProps, IAddUserCapabilityPanelState> {
    constructor(props: IAddUserCapabilityPanelProps) {
        super(props);

        this.state = {
            name: "",
            value: ""
        };
    }

    public render(): JSX.Element | null {
        if (this.props.isOpen) {
            const nameError: string | undefined = this._getNameErrorMessage();
            return (
                <Panel
                    className="pipelines-add-capability-panel"
                    titleProps={{
                        text: Resources.AddUserCapabilityTitle,
                        className: "fontWeightSemiBold"
                    }}
                    description={Resources.AddUserCapabilityDescription}
                    onDismiss={this._onDismiss}
                    footerButtonProps={[
                        {
                            text: Resources.Cancel,
                            onClick: this._onDismiss
                        },
                        {
                            text: Resources.Add,
                            primary: true,
                            onClick: this._onAddClick,
                            disabled: this._shouldDisableAddButton()
                        }
                    ]}>
                    <div className="flex-column flex-grow">
                        <FormItem
                            className="capability-name-textfield"
                            label={Resources.AddUserCapabilityNameLabel}
                            message={nameError}
                            error={nameError !== undefined}
                        >
                            <TextField
                                value={this.state.name}
                                required={true}
                                onChange={(ev, name: string) => (this.setState({ name }))}
                            />
                        </FormItem>
                        <FormItem
                            className="capability-value-textfield"
                            label={Resources.AddUserCapabilityValueLabel}
                        >
                            <TextField
                                value={this.state.value}
                                required={true}
                                onChange={(ev, value: string) => (this.setState({ value }))}
                            />
                        </FormItem>
                    </div>
                </Panel>
            );
        }

        return null;
    }

    private _onDismiss = (): void => {
        this.setState({
            name: "",
            value: ""
        });
        this.props.onDismiss();
    }

    private _onAddClick = (): void => {
        if (this._validInputs()) {
            this.props.onUserCapabilityAdded(this.state.name, this.state.value);
            this._onDismiss();
        }
    }

    private _shouldDisableAddButton = (): boolean => {
        return !this._validInputs();
    }

    private _validInputs(): boolean {
        return this.state.name.length > 0 &&
            this._getNameErrorMessage() === undefined;
    }

    private _getNameErrorMessage(): string | undefined {
        if (this.state.name) {
            if (this.state.name.trim().length === 0) {
                return Resources.InvalidCapabilityNameEmpty;
            }

            if (this.state.name.length > 255) {
                return Resources.InvalidCapabilityNameTooLong;
            }

            if (this.state.name.startsWith(" ") || this.state.name.endsWith(" ")) {
                return Resources.InvalidCapabilityNameWhitespace;
            }
        }

        return undefined;
    }
}
